<div class="docs-example-viewer-wrapper">
  <div class="docs-example-viewer-title">
    <div class="docs-example-viewer-title-spacer">{{ example?.title }}</div>

    <mad-icon-button (click)="toggleSourceView()" [matTooltip]="'View source'" type="button">
      <mat-icon>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 24 24"
          fit=""
          preserveAspectRatio="xMidYMid meet"
          focusable="false"
        >
          <path fill="none" d="M0 0h24v24H0V0z"></path>
          <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"></path>
        </svg>
      </mat-icon>
    </mad-icon-button>
  </div>

  @if (showSource) {
    <div class="docs-example-viewer-source">
      <mat-tab-group>
        @for (tabName of tabNames; track tabName) {
          <mat-tab [label]="tabName.toUpperCase()">
            <div class="docs-example-source-wrapper">
              <mad-icon-button
                type="button"
                class="docs-example-source-copy"
                title="Copy example source"
                aria-label="Copy example source to clipboard"
                [cdkCopyToClipboard]="example.getFile(tabName)"
              >
                <mat-icon>content_copy</mat-icon>
              </mad-icon-button>
              <pre><code [highlight]="example.getFile(tabName)"></code></pre>
            </div>
          </mat-tab>
        }
      </mat-tab-group>
    </div>
  }

  <div class="docs-example-viewer-body">
    <ng-template [cdkPortalOutlet]="selectedPortal"></ng-template>
  </div>
</div>
